import React from 'react';

const formatMoney = (n) => `$${(Number(n) || 0).toLocaleString('es-AR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
})}`;

const formatNumber = (n) => {
  const value = Number(n);
  if (!Number.isFinite(value)) return '-';
  return value.toLocaleString('es-AR', {
    maximumFractionDigits: 4,
  });
};

const formatValue = (value, unit) => {
  if (unit === '$') return formatMoney(value);
  const suffix = unit && unit !== '$' ? ` ${unit}` : '';
  return `${formatNumber(value)}${suffix}`;
};

const CalculationBreakdown = ({ preview, variables = [], formula = '' }) => {
  if (!preview?.resolved_values) return null;

  const byKey = new Map((variables || []).filter(v => v.key).map(v => [v.key, v]));
  if (!byKey.has('tiempo')) {
    byKey.set('tiempo', {
      key: 'tiempo',
      label: 'Tiempo de produccion',
      type: 'number',
      unit: 'h',
    });
  }
  if (!byKey.has('tiempo_minutos')) {
    byKey.set('tiempo_minutos', {
      key: 'tiempo_minutos',
      label: 'Tiempo de produccion',
      type: 'number',
      unit: 'min',
    });
  }
  const resolvedEntries = Object.entries(preview.resolved_values);
  const calculatedEntries = resolvedEntries
    .map(([key, value]) => ({ key, value, variable: byKey.get(key) }))
    .filter(item => item.variable?.type === 'calculated');
  const baseEntries = resolvedEntries
    .map(([key, value]) => ({ key, value, variable: byKey.get(key) }))
    .filter(item => item.variable?.type !== 'calculated');

  return (
    <div className="calculation-breakdown">
      <div className="breakdown-title">Detalle del cálculo</div>

      {calculatedEntries.length > 0 && (
        <div className="breakdown-section">
          <div className="breakdown-section-title">Variables calculadas</div>
          {calculatedEntries.map(({ key, value, variable }) => (
            <div className="breakdown-item" key={key}>
              <div className="breakdown-item-main">
                <span>{variable?.label || key}</span>
                <strong className="mono">{formatValue(value, variable?.unit)}</strong>
              </div>
              {variable?.formula && (
                <code className="breakdown-formula mono">{variable.formula}</code>
              )}
            </div>
          ))}
        </div>
      )}

      {baseEntries.length > 0 && (
        <div className="breakdown-section">
          <div className="breakdown-section-title">Valores usados</div>
          <div className="breakdown-grid">
            {baseEntries.map(({ key, value, variable }) => (
              <div className="breakdown-pill" key={key}>
                <span>{variable?.label || key}</span>
                <strong className="mono">{formatValue(value, variable?.unit)}</strong>
              </div>
            ))}
          </div>
        </div>
      )}

      {formula && (
        <div className="breakdown-section">
          <div className="breakdown-section-title">Fórmula final</div>
          <code className="breakdown-formula mono">{formula}</code>
        </div>
      )}
    </div>
  );
};

export default CalculationBreakdown;
